var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0669 2.39978C13.9701 2.30277 13.8552 2.22581 13.7286 2.17329C13.6021 2.12078 13.4664 2.09375 13.3294 2.09375C13.1924 2.09375 13.0567 2.12078 12.9301 2.17329C12.8036 2.22581 12.6886 2.30277 12.5919 2.39978L5.58355 9.40811C5.50629 9.48521 5.445 9.57678 5.40319 9.67759C5.36137 9.7784 5.33984 9.88647 5.33984 9.99561C5.33984 10.1048 5.36137 10.2128 5.40319 10.3136C5.445 10.4144 5.50629 10.506 5.58355 10.5831L12.5919 17.5914C13.0002 17.9998 13.6585 17.9998 14.0669 17.5914C14.4752 17.1831 14.4752 16.5248 14.0669 16.1164L7.95021 9.99978L14.0752 3.87478C14.4752 3.46645 14.4752 2.80811 14.0669 2.39978Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.2b4e6c0cb767231d0ae3ebafc187c2e4.svg";
export { ForwardRef as ReactComponent };